import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/nlp/banner_nlp.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service healthcare_banner android_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={8} xl={9} xxl={8} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                Natural Language Processing Services
              </h1>
              <span>Improve Customer Engagement with Integrated NLP</span>
              <p style={{ marginTop: "10px" }}>
                Integrate Natural Language Processing solutions across core
                operations and communication ends for better data processing,
                extract meaningful insights, automate complex redundant
                processes, and upscale operational efficiency. With a team of
                machine learning and data processing experts, TekRevol
                skillfully designs and deploys NLP systems based on proficient
                Natural Language Generation (NLG) models and smart big data
                management.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Book a Demo
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
